import React from "react";
import { Sheet, SheetContent } from "@exiftrator/shared/components/ui";

function ThreePaneWorkspace({
  isMobile,
  leftPane,
  centerPane,
  rightPane,
  desktopRightOpen = true,
  mobileLeftOpen = false,
  onMobileLeftOpenChange = () => {},
  mobileRightOpen = false,
  onMobileRightOpenChange = () => {},
  mobileLeftSheetSide = "bottom",
  mobileRightSheetSide = "right",
}) {
  if (isMobile) {
    const leftSheetClassName =
      mobileLeftSheetSide === "bottom"
        ? "max-h-[50vh] p-0"
        : "w-[85vw] max-w-[340px] p-0";
    const rightSheetClassName =
      mobileRightSheetSide === "bottom"
        ? "max-h-[85vh] p-0 overflow-hidden"
        : "w-[88vw] max-w-[360px] p-0";

    return (
      <>
        <div className="flex min-h-0 flex-1">{centerPane}</div>

        <Sheet open={mobileLeftOpen} onOpenChange={onMobileLeftOpenChange}>
          <SheetContent
            side={mobileLeftSheetSide}
            className={leftSheetClassName}
            showCloseButton={true}
          >
            {leftPane}
          </SheetContent>
        </Sheet>

        <Sheet open={mobileRightOpen} onOpenChange={onMobileRightOpenChange}>
          <SheetContent
            side={mobileRightSheetSide}
            className={rightSheetClassName}
            showCloseButton={true}
          >
            {rightPane}
          </SheetContent>
        </Sheet>
      </>
    );
  }

  return (
    <div className="flex min-h-0 flex-1">
      {leftPane}
      {centerPane}
      {desktopRightOpen && rightPane}
    </div>
  );
}

export default ThreePaneWorkspace;
